module.exports = __webpack_public_path__ + "img/logo_wave_writer.7949737e.png";